import { Award, Music2, MapPin, Sparkles } from "lucide-react";

const STATS = [
  { v: "177K", k: "Social reach (IG + FB)" },
  { v: "3×", k: "Platinum-certified hits" },
  { v: "1st", k: "At Abbey Road Studios" },
  { v: "10+", k: "Major industry awards" },
];

const CREDENTIALS = [
  {
    icon: Award,
    title: "Honours",
    body: "Best New Artiste (ABPBH '12) · Best Song APM '12 (Pulanglah) · Best Song Collaboration APM '14 & '16.",
  },
  {
    icon: Music2,
    title: "Certifications",
    body: "Triple Platinum (Kalau Aku Kaya) and Double Platinum on three further singles — Warner Music Malaysia.",
  },
  {
    icon: MapPin,
    title: "Stages",
    body: "Shared stages with Jason Mraz, Dashboard Confessional, Kris Dayanti, Afgan, Judika & Hafiz Suip.",
  },
  {
    icon: Sparkles,
    title: "Landmark",
    body: "1st Asian Male Artiste to fully record two songs at Abbey Road Studios, London (feat. J.R Richards, Dishwalla).",
  },
];

export const CreativePartner = () => {
  return (
    <section
      id="awi"
      data-testid="awi-section"
      className="relative bg-[color:var(--nr-bg-soft)] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        {/* Portrait + signature card */}
        <div className="lg:col-span-5 reveal">
          <div className="relative">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-[color:var(--nr-ink)]">
              <img
                src="/awi-portrait.png"
                alt="Awi Rafael — creative partner, Noah+Rayn"
                className="w-full h-full object-cover"
                data-testid="awi-portrait"
              />
            </div>
            {/* Floating credential ribbon */}
            <div className="hidden md:block absolute -bottom-7 -right-6 max-w-[260px] bg-[color:var(--nr-bg)] border border-[color:var(--nr-line)] rounded-xl p-5 shadow-sm">
              <div className="text-[0.65rem] uppercase tracking-[0.22em] text-[color:var(--nr-accent)] font-semibold">
                Recorded at
              </div>
              <div className="font-serif-display text-xl text-[color:var(--nr-ink)] leading-tight mt-1">
                Abbey Road Studios, London
              </div>
              <div className="text-xs text-[color:var(--nr-ink-soft)] mt-2 leading-relaxed">
                A first for any Asian male artiste — and now, a sensibility that
                shapes our homes.
              </div>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="lg:col-span-7 reveal">
          <p className="overline mb-4">Our creative partner</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] text-[color:var(--nr-ink)]">
            Awi Rafael.
          </h2>
          <p className="mt-4 text-[color:var(--nr-ink-soft)] text-base lg:text-lg leading-relaxed max-w-xl">
            Award-winning musician, producer &amp; Co-Managing Director of
            Newsantara Asia and Timbre Music Academy.
          </p>

          {/* Stats strip */}
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4 lg:gap-5">
            {STATS.map((s, i) => (
              <div
                key={i}
                data-testid={`awi-stat-${i}`}
                className="border-t border-[color:var(--nr-accent)]/60 pt-4"
              >
                <div className="font-serif-display text-3xl lg:text-4xl text-[color:var(--nr-ink)] leading-none">
                  {s.v}
                </div>
                <div className="text-[0.65rem] uppercase tracking-[0.18em] text-[color:var(--nr-ink-soft)] mt-2 leading-snug">
                  {s.k}
                </div>
              </div>
            ))}
          </div>

          {/* Credential grid */}
          <div className="mt-10 grid sm:grid-cols-2 gap-x-8 gap-y-6">
            {CREDENTIALS.map((c, i) => {
              const Icon = c.icon;
              return (
                <div
                  key={i}
                  data-testid={`awi-cred-${i}`}
                  className="flex gap-4"
                >
                  <div className="w-10 h-10 rounded-full bg-[color:var(--nr-bg)] flex items-center justify-center ring-1 ring-[color:var(--nr-line)] shrink-0">
                    <Icon size={16} className="text-[color:var(--nr-accent)]" />
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-[color:var(--nr-ink)] font-semibold">
                      {c.title}
                    </div>
                    <p className="text-sm text-[color:var(--nr-ink-soft)] leading-relaxed mt-1.5">
                      {c.body}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Tie-back quote */}
          <div className="mt-10 rounded-2xl bg-[color:var(--nr-bg)] border border-[color:var(--nr-accent)]/30 px-6 py-5 lg:px-8 lg:py-6">
            <p className="text-[color:var(--nr-ink)] leading-relaxed text-base lg:text-lg">
              <span className="font-serif-display italic text-[color:var(--nr-accent)]">
                What this means for your home —{" "}
              </span>
              the same artistic instinct that took a Singaporean musician to
              Abbey Road now shapes how a Noah+Rayn living room feels at
              7 p.m. on a Tuesday.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
